import React from 'react';
import { Link } from 'react-router-dom';
import { OutlineButton } from "./OutlineButton";
import { PrimaryButton } from "./PrimaryButton";
import { SecondaryButton } from "./SecondaryButton";
import { ButtonSize } from "./ButtonStyling";

export function LinkButton({id, link, text, imageUrl, marginTop = 0, type = 'primary', dataTest, fullWidth = false, className = '', size = ButtonSize.Small, style = {}, onClick = () => {}, disabled = false}: Props) {
  let buttonAttributes = {};
  if (!!id) {
    // @ts-ignore
    buttonAttributes.id = id;
  }
  if (!!dataTest) {
    // @ts-ignore
    buttonAttributes['data-test'] = dataTest;
  }
  if (disabled) {
    return (<InnerButton
      imageUrl={imageUrl}
      text={text}
      type={type}
      onClick={onClick}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled} />)
  }
  return (
    <Link style={{...style, marginTop: marginTop}} {...buttonAttributes}
          to={link}
          className={`${className} linkButton`}>
      <InnerButton
        imageUrl={imageUrl}
        text={text}
        type={type}
        onClick={onClick}
        size={size}
        fullWidth={fullWidth} />
    </Link>
  );
}

function InnerButton(props: Omit<Props, "link">) {
  const {imageUrl, text, type, onClick, size, fullWidth} = props;
  if (type === 'outline' || type === 'outline-borderless') {
    return <OutlineButton
      imageUrl={imageUrl}
      click={onClick}
      size={size}
      fullWidth={fullWidth}
      text={text}
      hideBorder={type === 'outline-borderless'}
      disabled={props.disabled} />
  } else if (type === 'grey' || type === 'outline-black') {
    return <SecondaryButton
      click={onClick}
      size={size}
      fullWidth={fullWidth}
      text={text}
      disabled={props.disabled} />
  }
  return <PrimaryButton
    imageUrl={imageUrl}
    click={onClick}
    size={size}
    fullWidth={fullWidth}
    text={text}
    disabled={props.disabled} />
}

interface Props {
  id?: string;
  text: string;
  type?: 'primary' | 'outline' | 'grey' | 'outline-borderless' | 'outline-black';
  onClick?: any;
  link: string;
  className?: string;
  size?: ButtonSize;
  fullWidth?: boolean;
  dataTest?: string;
  style?: any;
  imageUrl?: string;
  marginTop?: number;
  disabled?: boolean;
}
